import React from 'react';
import PropTypes from 'prop-types';
import { FilterSelect, inlineSelectComponents } from '@td/ui';
import { translate } from '@td/shared_utils';
import { STATUSE_CODES } from '../constants/filterOptions';

const { CheckboxOption } = inlineSelectComponents;
const STATUS_FILTER_OPTIONS = Object.values(STATUSE_CODES).map((value) => ({
  value,
  label: translate(null, 'provider_panel.statuses', value),
}));

const StatusFilter = React.memo(({ value, label, placeholder, onChange }) => (
  <FilterSelect
    isMulti
    isSearchable={false}
    components={{ Option: CheckboxOption }}
    label={label}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    options={STATUS_FILTER_OPTIONS}
  />
));

StatusFilter.propTypes = {
  value:       PropTypes.array.isRequired,
  label:       PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange:    PropTypes.func.isRequired
};

StatusFilter.displayName = 'StatusFilter';

export default StatusFilter;
